import React, { Dispatch, useRef, useEffect, MouseEvent } from 'react';
import '../../App.css';
import { IInjectInfo, IHotwash, IGameStatus } from '../../interfaces';
import { HostSelection } from '../../Classes1';
import { useAppDispatch } from '../../app/hooks'
import { updateHotwashSelection } from '../../features/hotwash/hotwashSlice'

interface TurnProps {
    setHotwashInjects: Dispatch<any>;
    setInjectItem: Dispatch<any>;
    injectItem: IInjectInfo;
    hotwashInjects: IInjectInfo[];
    turn: number;
    gameTimeInterval: number;
    setShowHotwashNodeTimeline: Dispatch<any>;
    setShowHotwashTurnTimeline: Dispatch<any>;
    hotwashStatus: IHotwash;
    updateHotwashStatus: Dispatch<any>;
    isHost: boolean;
    currentGame: IGameStatus;
    zoomLevel: number;
    setZoomLevel:  Dispatch<any>;
  }

  export interface InjectState {
    hasDropped: boolean
    hasDroppedOnChild: boolean;
  }

const HotwashTurn: React.FC<TurnProps> = ({ setHotwashInjects, hotwashInjects, turn, setInjectItem, injectItem, gameTimeInterval, setShowHotwashNodeTimeline, setShowHotwashTurnTimeline, hotwashStatus, updateHotwashStatus, isHost, currentGame, zoomLevel, setZoomLevel }) => {

  const dispatch: any = useAppDispatch();

    const valueRef = useRef<IInjectInfo[]>([])
    useEffect(() => {
        valueRef.current = hotwashInjects;
    });

    const hotwashInjectsRef = useRef<IInjectInfo[]>([])
    useEffect(() => {
      hotwashInjectsRef.current = hotwashInjects;
    });

    let turnInjects: IInjectInfo[] = [];

    for (let i = 0; i<hotwashInjects.length; i++) {
      if (hotwashInjects[i].startTurn === turn) {
        turnInjects.push(hotwashInjects[i])
      }
    }

    const selectTurn = async (ev: MouseEvent) => {
      ev.stopPropagation();
      //console.log("selectTurn:turn: ", turn)

      if (isHost) {
        let newHostSelection: any = {};
        newHostSelection.hotwashId = hotwashStatus.gameId;
        newHostSelection.hostSelection = new HostSelection();
        
        newHostSelection.hostSelection.page = '';
        newHostSelection.hostSelection.turn = turn;
        newHostSelection.hostSelection.inject = -1;
        newHostSelection.hostSelection.node = '';
        newHostSelection.hostSelection.nodeTab = '';
        newHostSelection.hostSelection.nodePlayerID = '';
        await dispatch(updateHotwashSelection(newHostSelection))
        updateHotwashStatus(hotwashStatus.gameId)
      }
    }

    return (
        <div className={`turn turn${turn} hotwash-turn`} onClick={selectTurn}>
          { hotwashStatus.currentSelection ? turn === hotwashStatus.currentSelection.turn ? <div className="hotwash-current-turn">Current Turn<img src="img/current-turn-bottom.svg" className="hotwash-current-turn-btm" alt="" /></div> : <div className="not-current-turn"></div> : <></> }
          <div className="hotwash-turn-label">Turn {turn}</div>

            {/*turnInjects.map((item: IInjectInfo, i: number) => {
              if (item.startTurn === turn) {
                  return (
                    <HotwashInject setHotwashInjects={setHotwashInjects} hotwashInjects={hotwashInjects} setInjectItem={setInjectItem} injectItem={injectItem} gameTimeInterval={gameTimeInterval} setShowHotwashNodeTimeline={setShowHotwashNodeTimeline} setShowHotwashTurnTimeline={setShowHotwashTurnTimeline} turn={turn} id={item.id.toString()} hotwashStatus={hotwashStatus} isHost={isHost} updateHotwashStatus={updateHotwashStatus} key={item.id} currentGame={currentGame} zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} />
                    )
                } else {
                  return <div key={item.id}></div>
                }
            })*/}
        </div>
    )
}

export default HotwashTurn;